import { splitData, splitNumbers } from '@helios/utils'
import {
  BulkClearwaterTransactionsGetRequest,
  FindBulkClearwaterTransactionsForm,
} from '../models/bulk-clearwater-transactions.model'
import { BulkClearwaterTransaction } from '../models/clearwater-transaction.model'

/**
 * Constructor for BulkClearwaterTransactionsGetRequest, which is created from form data.
 */
export function createBulkCwTransGetRequest(
  form: FindBulkClearwaterTransactionsForm,
): BulkClearwaterTransactionsGetRequest {
  const rootIds = splitNumbers(form.rootIds)
  const hasRootIds = rootIds.length > 0
  const isAccountIdType = form.rootIdType === 'account'
  const isClientIdType = form.rootIdType === 'client'
  const isTransactionType = form.rootIdType === 'transaction'
  const isLegacyTranType = form.rootIdType === 'legacyTransaction'
  const accountIds = hasRootIds && isAccountIdType ? rootIds : undefined
  const clientIds = hasRootIds && isClientIdType ? rootIds : undefined
  const assetIds =
    form.assetIds !== undefined && form.assetIds.length > 0
      ? splitData(form.assetIds)
      : undefined
  const tranTypes =
    form.tranTypes !== undefined && form.tranTypes.length > 0
      ? form.tranTypes
      : undefined

  const tranIds =
    hasRootIds && isTransactionType ? splitData(form.rootIds) : undefined
  const legacyTranIds = hasRootIds && isLegacyTranType ? rootIds : undefined

  return {
    filter: {
      accountIds,
      clientIds,
      tranIds,
      legacyTranIds,
      dateField: form.dateRangeType,
      beginDate: form.startDate,
      endDate: form.endDate,
      assetIds,
      tranTypes,
    },
  }
}

/**
 * checkBulkTransferOutNonEditableTransaction TRNO/EXOT bulk edit is not possibly unless all cw trans have loaded and in the selected ones all are single sided(empty xrefAccountId) or two sided
 */
export function checkBulkTransferOutNonEditableTransaction(
  cwTransactionsSelected: BulkClearwaterTransaction[],
) {
  if (cwTransactionsSelected.length <= 1) {
    //its not a bulk selection so return false
    return false
  }
  if (cwTransactionsSelected.some(cwTrans => cwTrans.tranTypeCode != 'TRNO')) {
    // its not all TRNO
    return false
  }
  if (
    cwTransactionsSelected.every(
      cwTrans => cwTrans.destAccountId === -1 || !cwTrans.destAccountId,
    )
  ) {
    // if all are -1 means they are calculated and single sided
    return false
  }
  if (
    cwTransactionsSelected.every(
      cwTrans => cwTrans.destAccountId && cwTrans.destAccountId != -1,
    )
  ) {
    // if all are not -1 means they are calculated and 2 sided
    return false
  } else {
    // if true they are either not yet calculated or are mix of 2 sided ans single sided
    return true
  }
}

/**
 * isTransactionIgnoredForCopy
 */
export function isTransactionIgnoredForCopy(
  cwTransactionsSelected: BulkClearwaterTransaction[],
) {
  //tranTypeCode to be added in list in case more trantype to ignore
  if (cwTransactionsSelected.some(cwTrans => cwTrans.tranTypeCode == 'LOAD')) {
    return true
  } else {
    return false
  }
}
